/* eslint-disable prettier/prettier */
/* eslint-disable quotes */
export default {
  en: 'English',
  selectPin: 'Select Pin en',
  hdrPin: 'PIN',
  hdrLogin: 'Login',
  hdrProviderLogin: 'Provider Login',
  hdrHome: 'Home',
  hdrMyBenefits: 'My Benefits',
  hdrDigitalCard: 'Digital Card',
  hdrMyHealth: 'My Health',
  hdrMyHealthSummary: 'My Health Summary',
  hdrHealthSummary: 'Health Summary',
  hdrMemberResource: 'Resources',
  hdrAlerts: 'Messages',
  hdrBroadCastAdmin: 'Preview Messages',
  hdrBroadCastMessage: 'Preview Messages',
  hdrMyProvider: 'My Providers',
  hdrMyFavorites: 'My Saved Providers',
  hdrFindProvider: 'My Providers',
  hdrUploadFile: 'Send To Agency',
  hdrError: 'Error',
  AppTitle: '<AppName>',
  errLoginUsrReq: 'Please enter Username',
  errLoginUsrMinReq: 'Please enter at least 8 characters for Username',
  errLoginUsrMaxReq: 'Please limit Username to a maximum of 20 characters',
  errLoginPasReq: 'Please enter Password',
  errLoginPasMinReq: 'Please enter at least 6 characters for Password',
  errLoginPasMaxReq: 'Please limit Password to a maximum of 12 characters',
  errLoginPassOnlyNum: 'Password should not contain characters',
  errLoginPasAlpReq:
    'Please include at least one character from numbers, mixed case letters, and special characters for Password',
  errRegisFirNamReq: 'Please enter First Name',
  errRegisFirMaxReq: 'Please limit First Name, maximum of 40 characters allowed',
  errRegisLasNamReq: 'Please enter Last Name',
  errRegisLasMaxReq: 'Please limit Last Name, maximum of 40 characters allowed',
  errRegisConUsrReq: 'Please enter Confirm Username',
  errRegisMobileReq: 'Please enter Mobile Number',
  errRegisMobileOnlyNumber: 'Please enter number only',
  errRegisMobileValid: 'Please enter Valid Mobile Number',

  errRegisConUsrMinReq: 'Please enter at least 8 characters for Confirm Username',
  errRegisConUsrMaxReq: 'Please limit Confirm Username to a maximum of 20 characters',
  errRegisConUsrMisReq: 'Please ensure that Username matches Confirm Username',
  errRegisConPasReq: 'Please enter Confirm Password',
  errRegisConPasMisReq: 'Please ensure that Password matches Confirm Password',
  errRegisMedIDReq: 'Please enter your Global ID OR Member ID',
  errRegisMedID: 'Please enter Member ID',
  errRegisMemberIDMaxReq: 'Please limit Member ID to a maximum of 20 characters',
  errRegisMedIDMaxReq:
    'Please limit Social Security Number or Member ID to a maximum of 20 characters',
  errRegisDatReq: 'Please enter Date of Birth',
  errRegisDatVal: 'Please enter Date of Birth in the format MM/DD/YYYY',
  errValidDOB: 'Please enter valid Date of Birth.',
  errInvalidAuth: 'Please enter valid verification code',
  errIncorrectDOB: 'Please enter the correct Date of Birth.',
  errSelectFM: 'Please select a family member ',
  errRegisCapchaVal: 'Please click on the text "I\'m not a robot."',
  errValPinMisMat: 'Please enter correct PIN',
  errValPinMisMatWarning:
    'Please note that your account may be disabled due to too many unsuccessful attempts',
  errValPinMisMatError:
    'Your account has been disabled due to too many unsuccessful attempts. Please re-register to enable your account.',
  errPinMisMat: 'Please ensure that PIN numbers match',
  errEnterSamePin: 'The New PIN cannot be same as the Current PIN',
  errServerNoRecordFound:
    'Unable to locate your record. Please try again with accurate information or contact us for further assistance.',
  errServerUnableUpdateCard:
    'Unable to update member information. Please review error log for further information.',
  errServerInvalidCredentials:
    'Please ensure that you are entering the correct user name and password. If you need to recover them, please click Forgot Password.',
  errServerPageNotFound:
    'Unable to display the page. Please try again later or contact us for further assistance.',
  errServerInternalError:
    'Unable to process your request. Please try again later or contact us for further assistance.',
  errServerAuthorizationDenied:
    'Unable to process your request. Please try again later or contact us for further assistance.',
  errGeneralMessage:
    'Unable to process your request. Please try again later or contact us for further assistance.',
  errConnectionTimedOut:
    'Unable to communicate with the server. Please try again later or contact us for further assistance.',
  errDigitalCardRetriveFMC:
    'Unable to verify the information you provided. Please try again with accurate information or contact us for further assistance.',
  errorSessionTimeout: 'Your session has timed out.',
  errServerUsernameExist: 'Please select a different Username',
  errUpdateMemberAccess: 'Error occurred while retrieving messages. Please try again.',
  errNoResponse: 'Did not get response from server',
  errValEmailReq: 'Please enter Email Address',
  errValEmailminlength: 'Please enter at least 5 characters for Email',
  errValEmailmaxlength: 'Please limit Email to a maximum of 40 characters',
  errValidEmail: 'Please enter a valid Email address.',
  errNoChangeInEmail: 'Please enter a new email to change email',
  errNoChangeInPhone: 'Please enter a new number to change phone number',
  errSharedMemIDReq: "Please enter the Member's ID number.",
  errSharedMemIDMaxReq: "Please limit Member's ID to a maximum of 20 characters",
  errSharedOTPReq: 'Please enter One Time Password (OTP) as shared by the member.',
  errSharedOTPExpired: 'One Time Password expired. Please obtain a new password from the member.',
  errSharedOTPConsumed:
    'One Time Password cannot be re-used. Please obtain a new password from the member.',
  errSharedOTPNotValid:
    'One Time Password is invalid. Please obtain a new password from the member.',
  errFileNotAvailable:
    'Unable to display the document. Please try again later or contact us for further assistance.',
  errConnectivityIssue:
    'Unable to provide answers at this time. Please try again later or contact us for further assistance.',
  errEnterValidFirstName: 'Please enter a valid First Name',
  errEnterValidLastName: 'Please enter a valid Last Name',
  errCannotMakeCall: 'Your device does not support call functionality',
  errURLNotSupported: 'Provided URL is not supported',
  errLocationReq: 'Please enter the Location',
  errValidLocationReq: 'Please enter the valid Location',
  errDistanceReq: 'Please enter the Distance',
  errProviderTypeReq: 'Please enter the Provider Type',
  errSpecialtyReq: 'Please enter the Specialty',
  errRegisMessageAdminMaxReq: 'Please limit to 255 characters',
  // errProviderNameReq: 'Please enter the Provider Name',
  errValidProviderName: 'Please enter a valid Provider Name',
  errFavoriteLimit: 'Favorite exceeds the limit, remove any favorite and save another one',
  errTotalHrsWorked: 'Please enter total hours worked',
  errEmployerName: 'Please enter Employer name',
  errEmployerAddress: 'Please enter Employer Address',
  errEmployerCity: 'Please enter Employer City',
  errEmployerZip: 'Please enter Employer zip code',
  errBusinessName: 'Please enter the Business Name',
  errBusinessNameLength: 'Business name should be less than 40 characters',
  errBusinessAddressLength: 'Address should be less than 256 characters',
  errBusinessCityLength: 'City should be less than 40 characters',
  errBusinessStateLength: 'State should be less than 40 characters',
  errBusinessZipLength: 'Zip code should be less than 10 characters',
  errDuplicateBusiness:
    'Duplicate Business cannot be added, you already have added <BUSINESS_NAME>',
  errNoCurrentAddress: 'No current address available',
  errAddress1: 'Please enter Address 1',
  errAddress1Length: 'Address 1 should be less than 256 characters',
  errAddress2Length: 'Address 2 should be less than 256 characters',
  errCity: 'Please enter City',
  errCityLength: 'City should be less than 40 characters',
  errState: 'Please select the State',
  errStateLength: 'State should be less than 40 characters',
  errZip: 'Please enter the Zip code',
  errZipLength: 'Zip Code should be less than 10 characters',
  errDateMisMatch: 'Start Date should be prior to end date',
  errDrugNameMinReq: 'Please enter at least 2 characters for Drug Name',
  errDrugNameMaxReq: 'Please limit Drug Name to a maximum of 20 characters',
  errDrugClassMinReq: 'Please enter at least 2 characters for Drug Class',
  errDrugClassMaxReq: 'Please limit Drug Class to a maximum of 20 characters',
  errDrugNameReq: 'Please enter Drug Name',
  errDrugClassReq: 'Please enter Drug Class',

  lblSecureCodeSentToRegMob: 'Verification code has been sent to your registered Mobile',
  lblSecureCodeSentToRegEmail: 'Verification code has been sent to your registered Email',
  lblSecureCodeSentSuccessfully: 'Verification code has been sent successfully',
  lblMemberBenefits: 'Member Benefits',
  lblLoginUsrNam: 'Username',
  lblLoginPas: 'Password',
  lblLoginForPas: 'Forgot Password',
  lblLoginReg: 'Register',
  lblLoginRememberMe: 'Remember Me',
  lblRegisterFirNam: 'First Name',
  lblRegisterLasNam: 'Last Name',
  lblRegisterDob: 'Date of Birth (MM/DD/YYYY)',
  lblRegisterSSNo: 'Social Security Number',
  lblRegisterNext: 'Next',
  lblRegisterConUsrNam: 'Confirm Username',
  lblRegisterOptTFA: '2-Step Verification:',
  lblRegisterMobileNo: 'Mobile',
  lblEmail: 'Email',
  lblAuthCodeSent: 'Auth Code has been sent to your Mobile',
  lblRegisterPass: 'Password',
  lblRegisterConPass: 'Confirm Password',
  lblSubmit: 'Submit',
  lblPinReEnt: 'Confirm PIN',
  lblSendOTP: 'Select following option to receive code:',
  lblOTPSendText1: 'Verification code has been sent to',
  lblOTPSendText2: ' - code expires in # minutes',
  lblBtnOTPSend: 'Send Code',
  lblBtnResendCode: 'Resend Code',
  lblVerifyCodeText: 'Enter Verification Code:',
  lblValPinHeading: 'MyARMedicaid',
  lblValPinHead1: 'Please enter your 4-digit PIN',
  lblLangSubmit: 'Confirm / Confirmar',
  lblLogout: 'Logout',
  lblPrint: 'PRINT',
  lblOR: 'OR',
  lblFamilyMemberCard: 'Family Member Card',
  lblMyCard: 'My Card',
  lblGenerateCard: 'Generate Card',
  lblTermsAgree:
    'By clicking Submit you are agreeing to opt in to receiving digital communications. Once registered, you can opt out at any time via a feature in the application menu.',
  lblTermsCondition: 'Terms of Service',
  lblShow: 'SHOW',
  lblHide: 'HIDE',
  lblClose: 'Close',
  lblBack: 'Back',
  lblIssuedOn: 'Issued on: ',
  lblStartDate: 'Start date: ',
  lblEndDate: 'End date: ',
  lblBeneficiaryNotEligible: 'Beneficiary is not eligible',
  lblCardNotValid: 'Card not active',
  lblMedicaidOrSSN: 'Member ID or SSN',
  lblMedicadId: 'Member ID or SSN',
  lblDigitalCardRefresh: 'Please login in order to refresh your digital card.',
  lblAutoRefreshCredential: 'Please login to refresh the contents of this page.',
  lblDigitalCardAutoRefresh: 'Refreshing your card...',
  lblAlertAutoRefresh: 'Refreshing your messages...',
  lblDate: 'Date:',
  lblExpires: 'Expiry:',
  lblNoNewAlert: 'No new messages',
  lblNewAlerts: 'New messages available',
  lblNoAlert: 'No Messages',
  lblNoMemRes: 'No resources are available',
  lblProviderOTP: 'Generate One Time Password',
  lblMemberID: 'Member ID',
  lblSharedOTP: 'One Time Password (OTP)',
  lblProviderLogin: 'Login',
  lblProviderDate: 'Printed on:',
  lblProviderIp: 'IP:',
  lblProviderEmail: 'Emailed:',
  lblStart: 'Start: ',
  lblID: 'ID: ',
  lblEnd: 'End: ',
  lblStatus: 'Status: ',
  lblMedicaidIDStatusNotValid: 'Your Medicaid ID Status is Inactive',
  lblProgram: 'Program: ',
  lblDOB: 'Birth Date: ',
  lblProgramCaseNumber: 'Your case number is ',
  lblNeedHelp: 'Need Help',
  lblyou: 'You: ',
  lblSupport: 'Support Bot: ',
  lblSend: 'Send',
  lblAskQuestionPlaceholder: 'Type your message here…',
  lblMemberInactive: 'Member Inactive',
  lblHello: 'Hello,',
  lblLoading: 'Loading...',
  lblAppointment: 'Appointment: ',
  lblCalendarSave: 'Appointment saved successfully. ',
  lblCalendarCancel: 'Appointment not saved. Please try again.',
  lblCalendarError: 'Appointment not saved. Please grant permission to access your calendar.',
  lblNotValidLink: 'Provided URL is not supported',
  lblNotValidPDFLink: 'Provided PDF is not supported',
  lblNotOpenDatePicker: 'Cannot open date selector',
  lblBroadcastDate: 'Broadcast Date',
  lblApprove: 'Approve',
  lblReject: 'Reject',
  lblApproved: 'Approved',
  lblRejected: 'Rejected',
  lblBroadCastSend: 'Broadcast Send',
  lblBroadcastFailure: 'Broadcast Fail',
  lblLocation: 'Location *',
  lblDistance: 'Distance (Miles) *',
  lblProviderType: 'Provider Type *',
  lblSpecialty: 'Specialty',
  lblSearchProvider: 'Find',
  lblProviderName: 'Provider Name',
  lblProvidersSearchResults: 'Found <count> Providers',
  lblNoProvidersSearchResults: 'No Providers Available',
  lblCommentApprove: 'You are approving the message.',
  lblCommentReject: 'You are rejecting the message.',
  lblValuableComment: 'Review comments',
  lblUserComment: 'Please enter your comments',
  lblCancel: 'Cancel',
  lblYes: 'Yes',
  lblNo: 'No',
  lblValidate: 'Verify',
  lblExitHead: 'Exit MyARMedicaid',
  lblExitText: 'Do you want to exit MyARMedicaid?',
  lblFavoriteResults: 'Number of Saved Providers: <count>',
  lblNoFavorite: 'No Saved Providers',
  lblPcpTitle: 'My PCP',
  lblNoPcp: 'You have not chosen PCP. You can choose one from the provider search results.',
  lblChoosePcp: 'Choose PCP',
  lblPcpSelected: 'My PCP',
  lblProfSetting: 'Profile Settings',
  lblOptOutAlertTitle: 'Do you want to proceed?',
  lblOptOutMsg:
    'Paper communications will resume and you will no longer receive new information on this app.',
  lblAfterOptOutMsg:
    'If you would like to opt-in to this app again in the future, please re-register to the app',
  lblOptOutResponseAlertTitle: 'Successful',
  lblOptOut: 'Opt Out',
  lblOptOutSuccessMsg: 'You have been opted-out from MyARMedicaid',
  lblOpenInMap: 'Open in Map',
  lblReset: 'Reset',
  lblClear: 'Clear',
  lblAddDetails: 'Address Details',
  lblResetPIN: 'Reset PIN',
  lblCurrentAdd: 'Current Address',
  lblModifyAdd: 'New/Modify Address',
  lblAddress1: 'Address 1',
  lblAddress2: 'Address 2',
  lblCity: 'City',
  lbState: 'State',
  lblZip: 'Zip Code',
  lblAge: 'Age',
  lblYear: 'Years',
  lblMonths: 'Months',
  lblGender: 'Gender',
  lblSelectTimeFrame: 'Select Time frame:',
  lblClaims: 'Claims',
  lblProcedures: 'Procedures',
  lblProcedureName: 'Procedure Name',
  lblImmunizations: 'Immunizations',
  lblPrescriptions: 'Prescriptions',
  lblProvidersSeen: 'Providers Seen',
  lblProvider: 'Provider:',
  lblClaimNo: 'Claim No:',
  lblName: 'Name:',
  lblProCode: 'Pro code:',
  lblDrugName: 'Drug Name:',
  lblDosage: 'Dosage:',
  lblPhone: 'Phone:',
  lblView: 'View',
  lblDownload: 'Download',
  lblDataDownloaded: 'Time frame: ',
  lblDataDownload: 'Downloaded on: ',
  lblExternalLinks: 'External Links',
  lblViewSharedCard: 'Digital Card',
  lblViewHealthSummary: 'Health Summary',

  hdrLoginHeading: 'Please login',
  hdrRegisterHeading: 'Please enter your enrollment information',
  hdrRegisterHeadingPage2: 'Please choose your login information',
  hdrRegisterHeadingPassword: 'Please select your password',
  hdrDigCardHeading: 'Your Card',
  hdrDigCardHeadingSelectCard: 'Select Card',
  hdrDigCardFamilyMember: 'Please select a Family Member',
  hdrDigCardMember: '<first name>’s Card',
  hdrPinHeading: 'Please choose a 4-digit PIN',
  hdrVerifyMFA: '2-Step Verification',
  hdrSetupMFA: 'Setup 2-Step Verification',
  hdrPinHead1:
    'This 4-digit PIN will be required to validate your access every time you launch this app.',
  hdrValPinHead1: 'Please enter your 4-digit PIN',
  hdrPinHeadingPinOnly: 'Please enter PIN',
  hdrPinHeadingFingerPrint: 'Please enter PIN OR use Face / Fingerprint recognization',
  hdgNoInternetHeading:
    'Your device does not have access to the Internet now. Please try again once connected to the Internet.',
  hdgNoInternetHeading2:
    'Your device is offline, an internet connection is required in order for the data to be displayed',
  hdrLanguageHeading: 'Language / Idioma',
  hdrLanguageSubHeading: 'Select Language',
  hdrShareCardHeading: 'Share Card',
  hdrFlipCardHeading: 'Flip Card',
  hdrShareCardOTP: 'One Time Password (OTP) : ',
  hdrShareCardOTPExpiry: 'OTP Expired : ',
  hdrShareCardText:
    'You may also send the access information to the service provider via email if requested.',
  hdrShareCardHeadText:
    'Please generate a One Time Password and then share the information displayed with the service provider.',
  hdrShareCardHeadOTPText: 'Please share the information displayed with your service provider.',
  hdrShareCardMemID: 'Member ID : ',
  hdrShareCardSendEmail: 'Send Email',
  hdrShareCardDone: 'Done',
  hdrShareCardTitle: 'Share <first name>’s Card',
  hdrShareCardInform: 'Access information has been sent to <first name>',
  hdrProviderMemberCardHeading: '<first name>’s MyARMedicaid Card',
  hdrProviderHeading: 'View MyARMedicaid Card',
  hdrBrowserNotSupport: 'Please use Chrome or Safari browser for optimal viewing experience.',
  hdrUploadingFile: 'Uploading Files',
  hrdTimeTracker: 'Time Tracker',
  hdrBusinessDetails: 'Business Details',
  hdrNeedHelp: 'How can I help you?',
  hdrFormulary: 'Formulary',
  cntRegisterPasswordHint:
    'Password should be 8-12 characters containing numbers, mixed case alphabets, and special characters',
  cntDigCardLastStored: 'Card last downloaded on',
  cntDigCardOfflineBefore:
    'To retrieve updates to this MyARMedicaid card, please click the menu option Login',
  cntDigCardOfflineAfter: 'in the top and enter your user name and password.',
  uploadReceipt: 'File Listing',
  lblFileSizeExceeds: 'The size of the file you are sending exceeds <FILE_SIZE>',
  lblNotValidFileFormate: 'You can only send images and pdf documents',
  lblCamera: 'Camera',
  lblProcessing: 'Processing',
  lblFileUploading: 'File Uploading',
  lblPartialUpload: 'Few files have been sent',
  lblUploadSubHeader: 'Number of file(s) to send: <count>',
  lblDeleteExtraFile1: 'You can upload only <count> files',
  lblDeleteExtraFile2: ' Please delete extra files and upload',
  lblFileUploadedSuccessfully: 'Successful file submission.',
  lblAddMore: 'Add',
  lblSendToAgencyPara:
    'We accept images and PDF documents each <FILE_SIZE> or less in size. You may send a maximum of <FILE_LIMIT> files at a time.',
  lblOk: 'OK',
  lblFileListingPara: 'You can select up to <FILE_LIMIT> Images/PDF documents.',
  lblTotalHrsWorked: 'Total Work Hours',
  lblEmployerName: 'Business Name',
  lblEmployerAddressSection: 'Business Address',
  lblEmployerAddress: 'Address',
  lblEmployerCity: 'City',
  lblEmployerZip: 'Zip Code',
  lblTimeTrackerHeader: 'Please Enter Time',
  lblTimeTrackerSummary: 'Total Hours Worked - <count>',
  lblBusinessName: 'Business Name',
  lblBusinessAddress: 'Address',
  lblBusinessCity: 'City',
  lblBusinessState: 'State',
  lblBusinessAdd: 'Add Business',
  lblDiscard: 'Discard',
  hdrCameraRollTitle: 'Camera Roll',
  lblValidHours: 'Please enter the valid Hours.',
  lblHourExceeded: 'Total Hours exceeded 24 hours',
  lblDiscarded: 'Discarded your changes',
  lblModuleId: 'ModuleID',
  lblUploadDocCurrentWeek: 'Supporting documents',
  lblTimeTrackerID: 'TimeTrackerID',
  lblTimeTrackerFileUploadPara: 'You are uploading documents for the selected date range',
  lblTimeTrackerSuccessMsg: 'Saved time entries',
  lblHours: 'Hours',
  weekDay1: 'Mon',
  weekDay2: 'Tue',
  weekDay3: 'Wed',
  weekDay4: 'Thu',
  weekDay5: 'Fri',
  weekDay6: 'Sat',
  weekDay7: 'Sun',
  hdrTimeTrackerSummary: 'Weekly Summary',
  hdrTimeTrackerFileUpload: 'Time Tracker - Docs',
  lblSelectDateRange: 'Select Date Range',
  lblUploads: 'Uploads',
  lblSelectDateRangeSummary: 'Select Date Range',
  lblSelectBusiness: 'Select Business',
  lblTotalHours: 'Total Hours: ',
  lblPermission: 'MyARMedicaid requires access to your camera and storage. Continue?',
  lblPermissionLocation: 'MyARMedicaid requires access to your location. Continue?',
  lblImageGallery: 'Image Gallery',
  lblPdfDocument: 'PDF Document',
  lblCalendarSaveEventError: 'Save Event Error',
  lblPermissionCalendar: 'MyARMedicaid requires access to your Calendar. Continue?',
  lblValPinReset: 'Please enter new PIN',
  lblPinResetSuccess: 'PIN has been updated successfully',
  lblCloseApp: 'Close Card',
  lblOptedOut: 'Opted Out',
  addressUpdateSuccess: 'Address updated successfully',
  LocaleUpdateSuccess: 'Language updated successfully',
  lblPageNotFound: 'Page Not Found',
  lblFingerPrint: 'Please scan your registered face or fingerprint on the device to continue',
  lblEmailTimer: 'Verification code expired for Email',
  lblMobileTimer: 'OTP expired for Mobile',
  lblEmailMobileTimer: 'OTP expired for both Email/Mobile',
  lblBtnMFAStop: 'Discontinue',
  lblStopMFA: 'Stop 2-Step Verification',
  lblActivatePhone: 'Activate Mobile',
  lblActivateEmail: 'Activate Email',
  lblConfirmStopMFA:
    'You will no longer be able to secure the App with 2-Step Verification. Are you sure, you want to discontinue?',
  lblStopPhone:
    'You will no longer be able to receive a verification code on Mobile. Are you sure, you want to Inactivate Phone?',
  lblStopEmail:
    'You will no longer be able to receive a verification code on Email. Are you sure, you want to Inactivate Email?',
  lblStartPhone:
    'You will start receiving a verification code to the Registered Mobile, Click YES to Activate Phone',
  lblStartEmail:
    'You will start receiving a verification code to the Registered Email, Click YES to Activate Email',
  lblOptedOutMFA: 'Set Up 2-Step Verification',
  lblMFAControllerInfo: 'Click on blue magnifier button to authenticate',
  lblBtnMFAComplete: 'Complete Set Up',
  lblBtnGoToHome: 'Go to home',
  lblSomethingWentWrong: 'Something went wrong, Please try again!',
  lblEmailIsDeactivated:
    'Email is already inactivated, Click on Discontinue button to stop 2-Step Verification',
  lblPhoneIsDeactivated:
    'Phone is already inactivated, Click on Discontinue button to stop 2-Step Verification',
  lblSkip: 'Skip to home',
  lblMedicalConditions: 'Drug Name',
  hdrFetchedInfo: 'Fetched Information',
  lblDrugClass: 'Drug Class',
  lblSearchDrug: 'Search Drug',
  lblDrugTypes: 'Select Drug Type',
  lblUsed: 'Used',
  lblDrugSearchResults: 'Drug Search Results',
  lblDrugList: 'Drug List',
  lblMfaSetupCompleted: 'You have successfully setup 2 Step Verification. Please continue to home.',
  lblBrowserPermission: 'Please enable your notification permission in browser',
  lblPendingMembership:
    'Your membership status is Pending. Full access will be granted upon approval.',
  lblGlobalID: 'Global ID',
  lblVersionNumber: 'Version No:',
  hrdDigitalCard:
    'The Member ID and One Time Password (OTP) shared by the member is required to view their Digital card',
  hrdHealthSummary:
    'The Member ID and One Time Password (OTP) shared by the member is required to view their Health Summary',
  lblPopupHeader1: 'Are you sure you want to close this Digital Card?',
  lblPopupHeader2:
    'If you press the OK button, you would not be able to View/Print this card again until you get a new OTP from the member',
  lblPopupHealthSummaryHeader1: 'Are you sure you want to close this member’s Health Summary?',
  lblPopupHealthSummaryHeader2:
    'If you press the OK button, you would not be able to Download/Print this Health Summary again until you get a new OTP from the member',
  errFileNameDoesNotExists:
    'Something went wrong with Health Summary Report - please ask Member to search their Health records and share it again.',
  errPermissionDenied:
    'Something went wrong with Health Summary Report - please ask the Member to search their Health Summary record and share it again.',
  errAccessCodeNotValid:
    'Invalid OTP - Please verify if you have entered the OTP correctly. Additionally, you may ask the Member to search their Health Summary record and share it again.',
  errAccessCodeExpired:
    'The OTP is already expired - please ask the Member to search their Health Summary record and share it again.',
  errAccessCodeConsumed:
    'The OTP has already been consumed - please ask the Member to search their Health Summary record and share it again.',
  errAccessCodeNotValidCard:
    'Invalid OTP - Please verify if you have entered the OTP correctly. Additionally, you may ask the Member to share their card again.',
  errAccessCodeExpiredCard:
    'The OTP is already expired - please ask the Member to share their card again.',
  errAccessCodeConsumedCard:
    'The OTP has already been consumed - please ask the Member to share their card again.',
  accLblMassachusettsCardFront: 'Digital Card front view of Massachusetts.',
  accLblMassachusettsCardBack: 'Digital Card back view of Massachusetts.',
  lblAccessibilityEnabled: 'MyARMedicaid app is now accessibility enabled',
};
